import React, { useContext } from 'react'
import { useTheme } from '@emotion/react'
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite/no-important'
import { ThemeContext } from '../theme'

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  style: PropTypes.object
}

const defaultProps = {
  className: '',
  style: {}
}

const styles = StyleSheet.create({
  nav: {
    display: 'flex',
    listStyleType: 'none',
    margin: '0',
    padding: '0'
    // '@media (max-width: 574px)': {
    //   justifyContent: 'space-between',
    //   width: '100vw'
    // }
  }
})

const Nav = (props) => {
  const context = useContext(ThemeContext)
  const theme = useTheme()
  let navbar
  if (theme && theme.navbar) {
    navbar = theme.navbar
  } else {
    navbar = context.theme.navbar
  }
  const { navbarHeight } = navbar

  return (
    <ul
      className={`${props.className} ${css(styles.nav)}`}
      style={{
        ...props.style,
        height: navbarHeight
      }}>
      {props.children}
    </ul>
  )
}

Nav.propTypes = propTypes
Nav.defaultProps = defaultProps
export { Nav }
